import { Card, Row } from 'react-bootstrap';
import type { Member, CurrentRyderCupTeamMember } from '../types/api.types';
import type { MatchSummary } from './head-to-head.utils';
import { TeamFlag } from './team-flag';
import { MatchSummaryDisplay } from './match-summary-display';
import { formatMemberName } from '../utils/members';

interface MemberCardProps {
  member: Member;
  isSelected: boolean;
  matchSummary: MatchSummary | undefined;
  onClick: () => void;
  showLatestRyderCupOnly: boolean;
  latestRyderCupTeams: CurrentRyderCupTeamMember[];
  reverse?: boolean;
}

const bodyStyle = { padding: 0 };

export const MemberCard = ({
  member,
  isSelected,
  matchSummary,
  onClick,
  showLatestRyderCupOnly,
  latestRyderCupTeams,
  reverse = false,
}: MemberCardProps) => {
  const memberTeam = showLatestRyderCupOnly ? latestRyderCupTeams.find((m) => m.id === member.id)?.team : undefined;
  const teamFlagElement = memberTeam ? <TeamFlag team={memberTeam} /> : null;
  const memberName = formatMemberName(member);

  return (
    <Row key={member.id}>
      <Card
        onClick={onClick}
        style={{
          cursor: 'pointer',
          border: '1px solid #ccc',
          marginBottom: '8px',
          backgroundColor: isSelected ? '#e7f3ff' : '#fff',
          boxShadow: isSelected ? '0 0 0 2px #007bff inset, 0 4px 8px rgba(0, 123, 255, 0.3)' : 'none',
          transition: 'all 0.2s ease-in-out',
        }}
      >
        <Card.Body style={bodyStyle}>
          {!reverse ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img
                src={`/assets/${member.id}.jpg`}
                alt=""
                style={{ width: '40px', objectFit: 'cover', flexShrink: 0 }}
              />
              {teamFlagElement}
              <div style={{ minWidth: 0, flex: 1 }}>
                <span style={{ fontWeight: 'bold' }}>{memberName}</span>
                <span>
                  {' '}
                  <MatchSummaryDisplay summary={matchSummary} />
                </span>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
              <div style={{ minWidth: 0, flex: 1, textAlign: 'right' }}>
                <span>
                  <MatchSummaryDisplay summary={matchSummary} />{' '}
                </span>
                <span style={{ fontWeight: 'bold' }}>{memberName}</span>
              </div>
              {teamFlagElement}
              <img
                src={`/assets/${member.id}.jpg`}
                alt=""
                style={{ width: '40px', objectFit: 'cover', flexShrink: 0 }}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    </Row>
  );
};
